export default "__VITE_ASSET__1M8tOfon__"